angular.module('bmsApp.merrymaids').factory('MMCleaningFrequencySvc', function (CRUDSvc) {

	return {
		options: function (params) {
			return CRUDSvc.get('api/merrymaids/cleaning-frequency/options', params);
		}
	}

});
